// extracted by mini-css-extract-plugin
export default {"container":"Vo-z","heading":"Wo-z","text":"Xo-z","info":"Yo-z","link":"Zo-z","fullMaxWidth":"_o-z"};